import {formatter, request} from '@/utils/request';

export namespace InvoiceMaker {
  export const Path = {
    Search: '/expenseapi/invoiceMaker/search',
    Get: '/expenseapi/invoiceMaker/get',
    AjaxSearch: '/expenseapi/invoiceMaker/ajaxSearch',
    SearchForSp: '/expenseapi/invoiceMaker/searchForSp',
  };

  export async function search(body: API.InvoiceMakerFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.InvoiceMaker[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.InvoiceMakerFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.InvoiceMaker[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function searchForSp(body: API.InvoiceMakerFilterForSp) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.InvoiceMaker[]>>(Path.SearchForSp, formatter(options));
  }

  export async function get(code: string) {
    const options = {
      method: 'GET',
      body: {
        code,
      },
    };
    return request<API.ResponseResult<API.InvoiceMaker>>(Path.Get, formatter(options));
  }
}
